import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  inject,
  Injector,
  NgZone,
} from '@angular/core';

import { FormControl, FormControlDirective, FormControlName, FormGroupDirective, NgControl } from '@angular/forms';

import { proxyOutputs } from './utils';

@Component({
    template: '',
    standalone: false
})
export abstract class BaseProxyComponent implements AfterViewInit {
  @HostBinding('attr.required')
  public _required?: boolean;

  public el: HTMLElement;
  public _ngZone = inject(NgZone);
  public formControl!: FormControl;

  private _cdRef = inject(ChangeDetectorRef);
  private _ref = inject(ElementRef);
  private injector = inject(Injector);

  constructor() {
    this._cdRef.detach();
    this.el = this._ref.nativeElement;

    const ctor = <any>this.constructor;
    if (ctor._outputs) {
      proxyOutputs(this, this.el, ctor._outputs);
    }
  }

  ngAfterViewInit() {
    const ngControl = this.injector.get(NgControl);
    let formControl: FormControl;

    if (ngControl instanceof FormControlName) {
      formControl = this.injector.get(FormGroupDirective).getControl(ngControl);
    } else if (ngControl instanceof FormControlDirective) {
      formControl = (ngControl as FormControlDirective).form as FormControl;
    }

    if (!formControl) return;

    const validators = formControl.validator ? formControl.validator({} as any) : null;

    if (validators && (validators['required'] || validators['requiredTrue'])) {
      this.el.setAttribute('required', '');
    }
  }
}
